/**
 * Shared value formatters used across the Smart-feature pages
 * (Consumption Events, Restock Events, etc).
 *
 * (2026-04-24, Jason Cox) Extracted from per-page duplicates in
 * DeliveryTickets.tsx / RestockEvents.tsx that were byte-identical.
 */

/**
 * Parse a money-like value from the backend, which may arrive as a number,
 * a string such as "$1,234.56", or undefined. Returns 0 on anything
 * unparseable so the caller can sum safely.
 */
export function parseMoney(v: string | number | undefined | null): number {
  if (typeof v === 'number') return v;
  if (typeof v === 'string') {
    const n = parseFloat(v.replace(/[^0-9.\-]/g, ''));
    return isNaN(n) ? 0 : n;
  }
  return 0;
}

/**
 * Format a number as USD with thousands separators and 2 decimals.
 * Display-only -- no locale override because we only render for en-US today.
 */
export function formatMoney(n: number): string {
  return '$' + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
